import SectionHeader from "./SectionHeader";

const REVIEWS = [
  {
    name: "山茶不是茶",
    tag: "综艺粉",
    text: "进群前总是一个人翻评论翻到头秃，进群后有人把时间线整理好，蹲到后续还有人第一时间喊我，体验直接起飞。",
    avatarColor: "bg-primary-100 text-primary-700",
  },
  {
    name: "西瓜不太甜",
    tag: "追更选手",
    text: "群规很友好，不吵架也不硬带节奏，聊得下去。预告做得挺准，好几次都是群里先炸我才反应过来。",
    avatarColor: "bg-accent-100 text-accent-800",
  },
  {
    name: "圈外人小李",
    tag: "新朋友",
    text: "本来是来围观的，结果被黑话科普和栏目整理圈粉，现在自己也学会理性吃瓜了，还拉了两个朋友一起进群。",
    avatarColor: "bg-secondary-100 text-secondary-800",
  },
];

export default function Reviews() {
  return (
    <section id="kouping" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="群友口碑"
          title="进来过的人都怎么说"
          desc="不是官方自夸，是真实蹲过料的同好留下的体验——抱团追更，真的比一个人香。"
        />

        <div className="mx-auto mt-8 flex w-fit items-center gap-3 rounded-full border border-background-200 bg-background-100 px-5 py-2.5">
          <div className="flex items-center gap-0.5 text-secondary-500">
            <i className="ri-star-fill" aria-hidden="true"></i>
            <i className="ri-star-fill" aria-hidden="true"></i>
            <i className="ri-star-fill" aria-hidden="true"></i>
            <i className="ri-star-fill" aria-hidden="true"></i>
            <i className="ri-star-fill" aria-hidden="true"></i>
          </div>
          <span className="text-sm font-semibold text-foreground-800">4.9 / 5</span>
          <span className="text-xs text-foreground-400">来自蹲料同好的综合评分</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {REVIEWS.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-200" aria-hidden="true"></i>
              <div className="mt-2 flex items-center gap-0.5 text-secondary-500">
                <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                <i className="ri-star-fill text-sm" aria-hidden="true"></i>
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full ${r.avatarColor}`}>
                  <i className="ri-user-smile-line text-lg" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-400">{r.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}